<template>
    <div>

        <template class="mt-5 mb-3" v-if="local.decisions.length > 0">
            <h4>What decision will I make?   </h4>

            <table class="table mb-5">
                <thead class="thead-light">
                <tr>
                   <!-- <th scope="col">Build order</th>-->
                    <th scope="col">Decision</th>
                    <th scope="col"></th>
                </tr>
                </thead>
                <tr v-for="(decision, decisionIndex) in local.decisions">
                    <!--<td>
                        {{decision.sequence}}
                    </td>-->
                    <td>
                        <input type="text" v-model="decision.name" :readonly="(decisionIndex != activeDecisionIndex)" class="form-control" :class="(decisionIndex == activeDecisionIndex) ? '':'readonly'">
                    </td>
                    <!--<td>
                        <button v-if="decision.sequence > DecisionTypesEnum.BEST && decision.sequence < DecisionTypesEnum.WORST"
                                class="btn btn-sm btn-outline-danger"
                                @click="removeDecision(decisionIndex)"><i class="fa fa-times"></i>
                        </button>
                    </td>-->
                    <td class="text-right">
                        <button :class="(decisionIndex == activeDecisionIndex) ? 'active':''" class="btn btn-outline-secondary btn-sm" title="Edit" @click="editDecision(decisionIndex)">
                            <i v-if="(decisionIndex == activeDecisionIndex)" class='far fa-save'></i>
                            <i v-else="(decisionIndex == activeDecisionIndex)" class='far fa-edit'></i>
                        </button>
                        <button class="btn btn-outline-danger btn-sm" title="Remove" @click="removeDecision(decisionIndex)">
                            <i class="fas fa-times"></i>
                        </button>
                    </td>
                </tr>
            </table>
        </template>

        <div>
            <template  v-if="decisionType == DecisionTypesEnum.BEST || decisionType == DecisionTypesEnum.WORST">
                <p>If you had ….</p>
                <table class="table border-bottom">
                    <tr  v-for="(consideration, considerationIndex) in local.considerations">
                        <td>
                            {{consideration.name}}
                        </td>
                        <td>
                            {{consideration.conditions.find(condition => condition.sequence == decisionType).name}}
                        </td>

                    </tr>
                </table>
            </template>

            <form>
                <div v-if="errors.length" class="alert alert-warning">
                    <ul>
                        <li v-for="error in errors">{{ error }}</li>
                    </ul>
                </div>


                <div class="form-group row" v-if="decisionType === DecisionTypesEnum.OTHER">
                    <div class="btn-group">
                        <button type="button" class="btn btn-secondary" @click.prevent="showForm = true" v-show="maxDecisions > local.decisions.length">Yes, add another</button>
                        <button type="button" class="btn btn-success" @click="considerationComplete">Next</button>
                    </div>
                </div>

                <div class="form-group row" v-if="showForm">
                    <label class="col-form-label col-md-2" for="decisionName">Decision</label>
                    <div class="col-md">
                        <input type="text" class="form-control" id="decisionName" v-model="local.decision.name" @keypress.enter.prevent="addDecision">
                    </div>
                    <div class="col-md-2">
                        <input type="button" class="btn btn-primary" value="Add" @click.prevent="addDecision">
                    </div>
                </div>
            </form>
        </div>

        <!--<div class="form-group row">
            <div class="col-md">
                <input type="text" class="form-control" placeholder="Decision to be made" id="decisionName" required v-model="local.decision.name">
            </div>
            <div class="col-md-2">
                <input type="button" class="btn btn-primary" value="Add" @click.prevent="addDecision">
            </div>
        </div>-->
    </div>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';
    import DecisionTypesEnum from '../types/ConditionTypesEnum';
    import {modalMixin} from '../mixins/modal';

    export default {
        mixins: [
            modalMixin,
        ],
        name: "DefineDecisionTable",
        data() {
            return {
                local: {
                    considerations: [],
                    decisions: [],
                    decision: {
                        name: ''
                    },
                },
                considerationIndex: 0,
                decisionType: DecisionTypesEnum.BEST,
                DecisionTypesEnum: DecisionTypesEnum,
                best: true,
                errors: [],
                showForm: true,
                activeDecisionIndex: -1,
            };
        },

        computed: {
            ...mapState('data', {
                dataConsiderations: state => state.matrix.considerations,
                dataDecisions: state => state.matrix.decisions,
            }),

            ...mapState('config', [
                'maxDecisions',
            ]),
        },

        methods: {

            ...mapMutations('data', [
                'commitConsiderations',
                'commitDecisionTable',
            ]),

            validate() {
                const vm = this;

                vm.$set(vm, 'errors', []);

                if (_.isEmpty(vm.local.decision.name)) {
                    vm.errors.push({name: 'Decision cannot be blank'});
                }
                return vm.errors.length === 0;
            },

            pushDecision(decision) {
                const vm = this;
                vm.local.decisions.push(decision);
                vm.$set(vm.local, 'decisions', _.sortBy(vm.local.decisions, 'sequence'));
            },

            addDecision() {
                const vm = this;

                if (vm.validate()) {
                    let decision = _.clone(vm.local.decision);
                    _.merge(decision, {sequence: vm.nextSequence()});
                    vm.pushDecision(decision);
                    vm.nextDecision();

                    vm.local.decision.name = '';
                    //vm.best = false;
                    vm.showForm = false;
                }
            },

            removeDecision(index) {
                const vm = this;
                vm.confirmAction('Are you sure you want to remove this decision?').then(value => {
                    if (value) {
                        vm.$delete(vm.local.decisions, index);

                        if(vm.local.decisions.length == 0) {
                            vm.decisionType = 0
                        }
                    }
                });


            },

            nextDecision() {
                const vm = this;
                switch (vm.decisionType) {
                    case DecisionTypesEnum.BEST:
                        vm.decisionType = DecisionTypesEnum.WORST;
                        break;
                    case DecisionTypesEnum.WORST:
                        vm.decisionType = DecisionTypesEnum.OTHER;
                        break;
                }
            },

            nextSequence() {
                const vm = this;
                return vm.decisionType === DecisionTypesEnum.WORST ? DecisionTypesEnum.WORST : vm.local.decisions.length;
            },

            considerationComplete() {
                const vm = this;
                // Store conditions
                //TODO: Move commit to addCondition to reduce potential data loss
                vm.commitDecisionTable(vm.local.decisions);
                // Reset local variable
                vm.$set(vm.local, 'decisions', []);

                // If more considerations, advance to next, otherwise next step
                //if (!vm.nextConsideration()) {
                    vm.nextStep();
                //}
            },

            restoreConditions() {
                const vm = this;

                if (_.isArray(vm.$store.state.data.matrix.decisions)) {

                    vm.local.decisions = _.clone(vm.$store.state.data.matrix.decisions);
                    if (_.find(vm.local.decisions, (item) => { return item.sequence == DecisionTypesEnum.WORST; })) {
                        vm.decisionType = DecisionTypesEnum.OTHER;
                    }
                    else if (_.find(vm.local.conditions, (item) => { return item.sequence == DecisionTypesEnum.BEST; })) {
                        vm.decisionType = DecisionTypesEnum.WORST;
                    }
                    else {
                        vm.decisionType = DecisionTypesEnum.BEST;
                    }
                }
            },

            nextStep() {
                this.$router.push({name: 'scoreassessment'});
            },


            resetErrors() {
                const vm = this;
                vm.$set(vm, 'errors', {
                    considerations: [
                        {
                            conditions: {

                            },
                        },
                    ],
                });
            },
            setConditionError(considerationIndex, conditionIndex, error) {
                const vm = this;

                let considerations = vm.errors.considerations;
                let payload = {
                    [considerationIndex]: {
                        conditions: {
                            [conditionIndex]: [
                                error
                            ]
                        }
                    }
                }

                vm.$set(vm.errors, 'considerations', _.merge(considerations, payload));
            },
            validateBestScores() {
                const vm = this;
                vm.resetErrors();

                for (var i in vm.local.considerations) {
                    let consideration = vm.local.considerations[i];
                    let bestCondition = consideration.conditions[0];
                    if (_.isEmpty(bestCondition).score) {
                        vm.setConditionError(i, 0, 'Score must be provided for each condition');
                    }
                    if (!(_.isNumber(bestCondition.score) && (bestCondition.score > consideration.conditions.length - 1))) {
                        vm.setConditionError(i, 0, 'Score for each condition must be equal or greater than the minimum');
                    }
                }


                return _.isEmpty(vm.errors.considerations[0].conditions);
            },
            allScores() {
                // TODO: Ensure all scores supplied and valid
                // TODO: advance to testing
            },

            editDecision(index) {
                if(this.activeDecisionIndex == index) {
                    this.activeDecisionIndex = -1;
                }else{
                    this.activeDecisionIndex = index;
                }
            },
        },
        mounted() {
            this.local.considerations = [...this.dataConsiderations];
            this.local.decisions = [...this.dataDecisions];
            this.restoreConditions();
        },

        watch: {
            'decisionType': function(type) {
                if (this.decisionType === DecisionTypesEnum.OTHER) {
                    this.showForm = false;
                }
                else {
                    this.showForm = true;
                }
            },
        },
    }
</script>

<style scoped>
    .readonly {
        background-color: transparent;
        border-width: 0;
    }
</style>
